module.exports = __webpack_public_path__ + "img/senioriales.19f0eb83.jpg";